<template>
  <!-- 設定画面 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>設定</h2>
      </CCardHeader>
      <CCardBody>
        <div class="container">
          <table class="table table-bordered" style="max-width: 800px">
            <tr>
              <td colspan="2">
                <h5 class="section-title mt-2 mb-2">基本情報</h5>
              </td>
            </tr>
            <tr>
              <th scope="row">会社名</th>
              <td>{{ items.company_name }}</td>
            </tr>
            <tr>
              <th scope="row">電話番号</th>
              <td>{{ items.telephone }}</td>
            </tr>
            <tr>
              <th scope="row">定時前打刻猶予時間</th>
              <td>{{ items.pre_buffer }}</td>
            </tr>
            <tr>
              <th scope="row">定時後打刻猶予時間</th>
              <td>{{ items.post_buffer }}</td>
            </tr>
            <tr>
              <th scope="row" v-html="postBufferBreakHeader"></th>
              <td>{{ items.post_work_break_flg ? 'はい' : 'いいえ' }}</td>
            </tr>
            <tr>
              <th scope="row">勤務時間の最小単位</th>
              <td>{{ items.work_time_unit }}</td>
            </tr>
            <tr>
              <th scope="row">規定定時間</th>
              <td>{{ items.work_basic }}</td>
            </tr>
            <tr>
              <th scope="row">規定休憩時間</th>
              <td>{{ items.break_basic }}</td>
            </tr>
            <tr>
              <th scope="row" v-html="projectBreakHeader"></th>
              <td>{{ items.use_project_break_flg ? 'はい' : 'いいえ' }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h5 class="section-title mt-2 mb-2">Slack通知</h5>
              </td>
            </tr>
            <tr>
              <th scope="row">workspaceトークン</th>
              <td>{{ items.slack_token }}</td>
            </tr>
            <tr>
              <th scope="row">チャンネルID</th>
              <td>{{ items.slack_channel }}</td>
            </tr>
          <!-- 有休付与ルール（年数 ↔ 付与日数） -->
          <tr>
            <td colspan="2">
              <h5 class="section-title mt-4 mb-2">有休付与</h5>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <tr>
                <th class="plr-rowhead">勤続年数</th>
                <th v-for="(c,i) in plrColumns" :key="'h'+i" class="plr-colhead">{{ c.label }}</th>
              </tr>
              <tr>
                <th class="plr-rowhead">休暇日数</th>
                <td v-for="(c,i) in plrColumns" :key="'d'+i">{{ c.days }}</td>
              </tr>
              <div v-if="plrColumns.length === 0" class="text-muted p-2">設定なし</div>
            </td>
          </tr>
          </table>
          <div class="text-center mt-4">
            <router-link :to="{ name: SettingUpdate, params: { value: items } }">
              <button class="btn btn-info">編集</button>
            </router-link>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import ConstList from "../ConstList";
export default {
  name: "info",
  data() {
    return {
      // 取得してきたクライアント情報のリスト
      items: {
      company_name: "",
      telephone: "",
      pre_buffer: "",
      post_buffer: "",
      work_time_unit: "",
      work_basic: "",
      break_basic: "",
      post_work_break_flg: false,
      use_project_break_flg: false,
      slack_token: "",
      slack_channel: "",
    },
      errors: [],
      SettingUpdate: "",
      clientInfo: "",
      //paidLeaveRules: [],
   // ← 有休付与ルール（モック）
   paidLeaveRules: [
     // display_label を入れると見出しを任意表示できます（無ければ "X年目" 表示）
     { id: 1,  service_year: 1, display_label: '6か月',     granted_days: '10', remarks: '' },
     { id: 2,  service_year: 2, display_label: '1年6か月', granted_days: '11', remarks: '' },
     { id: 3,  service_year: 3, display_label: '2年6か月', granted_days: '12', remarks: '' },
     { id: 4,  service_year: 4, display_label: '3年6か月', granted_days: '14', remarks: '' },
     { id: 5,  service_year: 5, display_label: '4年6か月', granted_days: '16', remarks: '' },
     { id: 6,  service_year: 6, display_label: '5年6か月', granted_days: '18', remarks: '' },
     { id: 7,  service_year: 7, display_label: '6年6か月', granted_days: '20', remarks: '' },
     { id: 8,  service_year: 8, display_label: '7年6か月', granted_days: '20', remarks: '' }, // ← 直前と同じ→以降列を自動追加
   ],
      // 二重サブミット対処フラグ
      submit_flg: false,
    };
  },
  computed: {
    postBufferBreakHeader() {
    const label = '定時後打刻猶予時間を休憩とする';
    if (window.innerWidth <= 768) {
      return '定時後打刻猶予時間を<br>休憩とする';
    }
    return label;
  },
    projectBreakHeader() {
      const label = 'プロジェクト設定の休憩時間を自動設定する';
      // スマホ判定
      if (window.innerWidth <= 768) {
        return 'プロジェクト設定の<br>休憩時間を自動設定する';
      }
      return label;
    },
    // 表示用：横並び列データを生成（PCテーブル/スマホ縦リスト共通）
    plrColumns() {
      const rows = Array.isArray(this.paidLeaveRules)
        ? [...this.paidLeaveRules].sort((a,b)=>(a.service_year||0)-(b.service_year||0))
        : [];
      const cols = rows.map(r => ({
        label: `${r.service_year}年目`,
        days:  (r.granted_days != null && r.granted_days !== '') ? `${r.granted_days} 日` : '-',
        remarks: r.remarks || ''
      }));
      // 最後とその1つ前の付与日数が同じなら「以降1年ごと」を自然に補う
      if (rows.length >= 2) {
        const last = String(rows[rows.length-1].granted_days ?? '');
        const prev = String(rows[rows.length-2].granted_days ?? '');
        if (last !== '' && last === prev) {
          cols.push({ label: '以降 1年ごと', days: `${last} 日`, remarks: '' });
        }
      }
      return cols;
    },
  },
  created() {
    this.SettingUpdate = ConstList.ROUTE_SETTING_UPDATE;
  },

  methods: {
    callList: function () {
      {
        axios
          .get((process.env.VUE_APP_API_ORIGIN) + '/setting/info')
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },

    // モーダルを表示
    openModal: function (item) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.showModal = true;
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
  },
};
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
